export default __webpack_public_path__ + "99a3c8748c3960640301167d1ef5581c.png";